// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer-space1-W4ApO {
	margin-bottom: 6px !important;
}

.Footer-space2-Mp_Oc {
	margin-bottom: 12px !important;
}

.Footer-space3-GHLXm {
	margin-bottom: 18px !important;
}

.Footer-space4-lCkz0 {
	margin-bottom: 24px !important;
}

.Footer-space5-gVBe4 {
	margin-bottom: 30px !important;
}

.Footer-space6-RQLAF {
	margin-bottom: 36px !important;
}

.Footer-space7-Ck4lD {
	margin-bottom: 42px !important;
}

.Footer-spaceTop8-AfDwF {
	margin-bottom: 48px !important;
}

.Footer-spaceTop1-vFVc8 {
	margin-top: 6px !important;
}

.Footer-spaceTop2-mqMV0 {
	margin-top: 12px !important;
}

.Footer-spaceTop3-Nx5vS {
	margin-top: 18px !important;
}

.Footer-spaceTop4-_Et4b {
	margin-top: 24px !important;
}

.Footer-spaceTop5-oobdo {
	margin-top: 30px !important;
}

.Footer-spaceTop6-CUi38 {
	margin-top: 36px !important;
}

.Footer-spaceTop7-hhWvp {
	margin-top: 42px !important;
}

.Footer-spaceTop8-AfDwF {
	margin-top: 48px !important;
}

.Footer-noMargin-y5mrr {
	margin: 0px !important;
}

.Footer-padding1-wP8xG {
	padding-bottom: 6px !important;
}

.Footer-padding2-yak9z {
	padding-bottom: 12px !important;
}

.Footer-padding3-XTqc_ {
	padding-bottom: 18px !important;
}

.Footer-padding4-tHNcs {
	padding-bottom: 24px !important;
}

.Footer-padding5-KSHlP {
	padding-bottom: 30px !important;
}

.Footer-padding6-cSHhn {
	padding-bottom: 36px !important;
}

.Footer-padding7-SNpkY {
	padding-bottom: 42px !important;
}

.Footer-paddingTop1-oroVE {
	padding-top: 6px !important;
}

.Footer-paddingTop2-yI6y4 {
	padding-top: 12px !important;
}

.Footer-paddingTop3-NRxOe {
	padding-top: 18px !important;
}

.Footer-paddingTop4-DFK7U {
	padding-top: 24px !important;
}

.Footer-paddingTop5-uoMEZ {
	padding-top: 30px !important;
}

.Footer-paddingTop6-c4OGH {
	padding-top: 36px !important;
}

.Footer-paddingTop7-CY73d {
	padding-top: 42px !important;
}

.Footer-noPadding-qJiE5 {
	padding: 0px !important;
}

.Footer-textBold-lZNgM {
	font-weight: 500 !important;
}

.Footer-textBolder-qxnUl {
	font-weight: 700 !important;
}

.Footer-textNormal-mmSc7 {
	font-weight: normal !important;
}

.Footer-spaceBottom20-B7C5T {
	margin-bottom: 20px;
}

.Footer-spaceBottom10-FVueb {
	margin-bottom: 10px;
}

.Footer-marginNone-Bc0z2 {
	margin: 0;
}

.Footer-spaceBottom15-Im7l2 {
	margin-bottom: 15px;
}

.Footer-marginTopNone-cC3gR {
	margin-top: 0;
}

.Footer-spaceTop11-zl_Kw {
	margin-top: 11px;
}

.Footer-spaceTop21-cNFFR {
	margin-top: 21px;
}

.Footer-spaceTop20-lBJeR {
	margin-top: 20px;
}

.Footer-spaceTop10-kbhdI {
	margin-top: 10px;
}

/*New Design Text Colors */

.Footer-textDarkBlue-Xfweg {
	color: rgb(20, 39, 94) !important;
}

.Footer-textLightBlue-iIpjK {
	color: rgb(57, 87, 106) !important;
}

.Footer-textLightSandleGreen-WGn6Q {
	color: rgb(76, 86, 41) !important;
}

.Footer-textLightBrown-lU85d {
	color: rgb(115, 79, 33) !important;
}

.Footer-textMediumMaroon-d4w93 {
	color: rgb(87, 37, 51) !important;
}

.Footer-textBrown-EdFmG {
	color: rgb(160, 47, 24) !important;
}

.Footer-textMaroon-FjO19 {
	color: rgb(155, 49, 67) !important;
}

.Footer-textDarkBrown-tHDPu {
	color: rgb(83, 18, 16) !important;
}

.Footer-textMediumBrown-uRV1L {
	color: rgb(142, 28, 10) !important;
}

.Footer-textSkyBlue-DseOT {
	color: rgb(37, 117, 141) !important;
}

.Footer-textGray-okigF {
	color: rgb(77, 65, 51) !important;
}

.Footer-footerSectionContainer-JLLFy {
	max-width: var(--max-content-width);
	margin: 0 auto;
	position: relative;
	display: block;
}

.Footer-displayGrid-rvHGC {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: 15px;
}

.Footer-textLink-vUOuA {
	color: var(--secondary-foreground);
	font-weight: normal;
	cursor: pointer;
	font-size: 14px;
}

.Footer-textLink-vUOuA:hover,
.Footer-textLink-vUOuA:focus,
.Footer-textLink-vUOuA:hover:focus {
	color: var(--secondary-foreground);
}

.Footer-listContainer-coPwN {
	padding: 0px;
	list-style-type: none;
	margin: 0px;
}

.Footer-landingLabel-uPryf {
	font-size: 16px;
	font-weight: 600;
	display: block;
	line-height: 18px;
	color: var(--primary-foreground);
}

.Footer-footerBgBanner-mPI8e {
	width: 100%;
	position: relative;
	background-color: var(--footer-bg) !important;
}

.Footer-displayInlineBlock-tRSu9 {
	display: inline-block;
}

.Footer-footerSiteName-mNwt_ {
	color: var(--primary-foreground);
}

.Footer-socialIcons-i0X1R {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
	gap: 9px;
}

.Footer-copyrightSection-IXOnm {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	margin-top: 40px;
	padding-top: 40px;
	border-top: 1px solid var(--primary-border);
}

.Footer-appsSectionFlex-pszan {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	gap: 10px;
}

.Footer-footerSectionPadding-LSQlm {
	padding: 60px 0px;
}

@media screen and (max-width: 767px) {
	.Footer-displayGrid-rvHGC {
		grid-template-columns: repeat(1, minmax(0, 1fr));
	}

	.Footer-copyrightSection-IXOnm {
		margin-top: 20px;
		padding-top: 20px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,mCAAmC;CACnC,cAAc;CACd,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,gDAAgD;CAChD,SAAS;AACV;;AAEA;CACC,kCAAkC;CAClC,mBAAmB;CACnB,eAAe;CACf,eAAe;AAChB;;AAEA;;;CAGC,kCAAkC;AACnC;;AAEA;CACC,YAAY;CACZ,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,6CAA6C;AAC9C;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;CACzB,QAAQ;AACT;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,gBAAgB;CAChB,iBAAiB;CACjB,2CAA2C;AAC5C;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,mBAAe;KAAf,eAAe;CACf,SAAS;AACV;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC;EACC,gDAAgD;CACjD;;CAEA;EACC,gBAAgB;EAChB,iBAAiB;CAClB;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../helpers.css';\n\n.footerSectionContainer {\n\tmax-width: var(--max-content-width);\n\tmargin: 0 auto;\n\tposition: relative;\n\tdisplay: block;\n}\n\n.displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(4, minmax(0, 1fr));\n\tgap: 15px;\n}\n\n.textLink {\n\tcolor: var(--secondary-foreground);\n\tfont-weight: normal;\n\tcursor: pointer;\n\tfont-size: 14px;\n}\n\n.textLink:hover,\n.textLink:focus,\n.textLink:hover:focus {\n\tcolor: var(--secondary-foreground);\n}\n\n.listContainer {\n\tpadding: 0px;\n\tlist-style-type: none;\n\tmargin: 0px;\n}\n\n.landingLabel {\n\tfont-size: 16px;\n\tfont-weight: 600;\n\tdisplay: block;\n\tline-height: 18px;\n\tcolor: var(--primary-foreground);\n}\n\n.footerBgBanner {\n\twidth: 100%;\n\tposition: relative;\n\tbackground-color: var(--footer-bg) !important;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n}\n\n.footerSiteName {\n\tcolor: var(--primary-foreground);\n}\n\n.socialIcons {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tgap: 9px;\n}\n\n.copyrightSection {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-top: 40px;\n\tpadding-top: 40px;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.appsSectionFlex {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 10px;\n}\n\n.footerSectionPadding {\n\tpadding: 60px 0px;\n}\n\n@media screen and (max-width: 767px) {\n\t.displayGrid {\n\t\tgrid-template-columns: repeat(1, minmax(0, 1fr));\n\t}\n\n\t.copyrightSection {\n\t\tmargin-top: 20px;\n\t\tpadding-top: 20px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Footer-space1-W4ApO`,
	"space2": `Footer-space2-Mp_Oc`,
	"space3": `Footer-space3-GHLXm`,
	"space4": `Footer-space4-lCkz0`,
	"space5": `Footer-space5-gVBe4`,
	"space6": `Footer-space6-RQLAF`,
	"space7": `Footer-space7-Ck4lD`,
	"spaceTop8": `Footer-spaceTop8-AfDwF`,
	"spaceTop1": `Footer-spaceTop1-vFVc8`,
	"spaceTop2": `Footer-spaceTop2-mqMV0`,
	"spaceTop3": `Footer-spaceTop3-Nx5vS`,
	"spaceTop4": `Footer-spaceTop4-_Et4b`,
	"spaceTop5": `Footer-spaceTop5-oobdo`,
	"spaceTop6": `Footer-spaceTop6-CUi38`,
	"spaceTop7": `Footer-spaceTop7-hhWvp`,
	"noMargin": `Footer-noMargin-y5mrr`,
	"padding1": `Footer-padding1-wP8xG`,
	"padding2": `Footer-padding2-yak9z`,
	"padding3": `Footer-padding3-XTqc_`,
	"padding4": `Footer-padding4-tHNcs`,
	"padding5": `Footer-padding5-KSHlP`,
	"padding6": `Footer-padding6-cSHhn`,
	"padding7": `Footer-padding7-SNpkY`,
	"paddingTop1": `Footer-paddingTop1-oroVE`,
	"paddingTop2": `Footer-paddingTop2-yI6y4`,
	"paddingTop3": `Footer-paddingTop3-NRxOe`,
	"paddingTop4": `Footer-paddingTop4-DFK7U`,
	"paddingTop5": `Footer-paddingTop5-uoMEZ`,
	"paddingTop6": `Footer-paddingTop6-c4OGH`,
	"paddingTop7": `Footer-paddingTop7-CY73d`,
	"noPadding": `Footer-noPadding-qJiE5`,
	"textBold": `Footer-textBold-lZNgM`,
	"textBolder": `Footer-textBolder-qxnUl`,
	"textNormal": `Footer-textNormal-mmSc7`,
	"spaceBottom20": `Footer-spaceBottom20-B7C5T`,
	"spaceBottom10": `Footer-spaceBottom10-FVueb`,
	"marginNone": `Footer-marginNone-Bc0z2`,
	"spaceBottom15": `Footer-spaceBottom15-Im7l2`,
	"marginTopNone": `Footer-marginTopNone-cC3gR`,
	"spaceTop11": `Footer-spaceTop11-zl_Kw`,
	"spaceTop21": `Footer-spaceTop21-cNFFR`,
	"spaceTop20": `Footer-spaceTop20-lBJeR`,
	"spaceTop10": `Footer-spaceTop10-kbhdI`,
	"textDarkBlue": `Footer-textDarkBlue-Xfweg`,
	"textLightBlue": `Footer-textLightBlue-iIpjK`,
	"textLightSandleGreen": `Footer-textLightSandleGreen-WGn6Q`,
	"textLightBrown": `Footer-textLightBrown-lU85d`,
	"textMediumMaroon": `Footer-textMediumMaroon-d4w93`,
	"textBrown": `Footer-textBrown-EdFmG`,
	"textMaroon": `Footer-textMaroon-FjO19`,
	"textDarkBrown": `Footer-textDarkBrown-tHDPu`,
	"textMediumBrown": `Footer-textMediumBrown-uRV1L`,
	"textSkyBlue": `Footer-textSkyBlue-DseOT`,
	"textGray": `Footer-textGray-okigF`,
	"footerSectionContainer": `Footer-footerSectionContainer-JLLFy`,
	"displayGrid": `Footer-displayGrid-rvHGC`,
	"textLink": `Footer-textLink-vUOuA`,
	"listContainer": `Footer-listContainer-coPwN`,
	"landingLabel": `Footer-landingLabel-uPryf`,
	"footerBgBanner": `Footer-footerBgBanner-mPI8e`,
	"displayInlineBlock": `Footer-displayInlineBlock-tRSu9`,
	"footerSiteName": `Footer-footerSiteName-mNwt_`,
	"socialIcons": `Footer-socialIcons-i0X1R`,
	"copyrightSection": `Footer-copyrightSection-IXOnm`,
	"appsSectionFlex": `Footer-appsSectionFlex-pszan`,
	"footerSectionPadding": `Footer-footerSectionPadding-LSQlm`
};
module.exports = ___CSS_LOADER_EXPORT___;
